import { render, staticRenderFns } from "./curd.vue?vue&type=template&id=601beb88&scoped=true&"
import script from "./curd.vue?vue&type=script&lang=js&"
export * from "./curd.vue?vue&type=script&lang=js&"
import style0 from "./curd.vue?vue&type=style&index=0&id=601beb88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601beb88",
  null
  
)

export default component.exports